// extracted by mini-css-extract-plugin
export default {"list":"Filters_list__oR+la","item":"Filters_item__IBAG1","link":"Filters_link__rXWu6"};